import ReactDOM from 'react-dom';
var isReact18 = ReactDOM.createRoot !== undefined;
/**
 * A unified render function that works with both React 17 and React 18.
 * @param component - The root React component to render.
 * @param container - The DOM element to mount the React component.
 */
function renderApp(component, container) {
    if (isReact18) {
        var root = ReactDOM.createRoot(container);
        root.render(component);
    }
    else {
        // Fallback to React 17's `ReactDOM.render`
        // eslint-disable-next-line react/no-deprecated
        ReactDOM.render(component, container);
    }
}
export default renderApp;
//# sourceMappingURL=renderApp.js.map